import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

interface Label {
  label: string;
  value: number;
  color: string;
  checked?: boolean;
}

export const ADD_LABEL_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AddLabelPickerComponent),
  multi: true
};

@Component({
  selector: 'host-add-label-picker',
  templateUrl: './add-label-picker.component.html',
  styleUrls: ['./add-label-picker.component.scss'],
  providers: [ ADD_LABEL_PICKER_VALUE_ACCESSOR ],
})
export class AddLabelPickerComponent implements OnInit, ControlValueAccessor {
  @Input() listOfLabel: Label[] = [];

  visible = false;

  get selectedLabels() {
    return this.listOfLabel?.filter(label => label.checked);
  }

  _registerOnChange: (value: any) => void = (_: any) => {};

  trackById = label => label.value;

  constructor() { }

  ngOnInit() {
  }

  onClose () {
    this.visible = false;
  }

  onCheckChange() {
    this._registerOnChange(this.selectedLabels?.map(label => label.value));
  }

  onCancelCheck (label) {
    label.checked = false;
    this.onCheckChange();
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(value: number[]): void {
    if (value?.length && !this.listOfLabel.length) {
      setTimeout(() => {
        this.writeValue(value);
      }, 500);
      return;
    }
    this.listOfLabel = this.listOfLabel.map(label => ({
      ...label,
      checked: (value ?? []).includes(label.value)
    }))
    // this.listOfLabel.forEach(label => {
    //   label.checked = (value ?? []).includes(label.value)
    // })
  }

}
